<template>
  <div class="upgrades">
    <UpgradeCard 
      v-for="upgrade in upgrades" 
      :key="upgrade.id"
      :upgrade="upgrade"
    />
  </div>
</template>

<script setup lang="ts">
import UpgradeCard from './UpgradeCard.vue';
import type { UpgradeEntity } from '@/types/UpgradeEntity';

defineProps<{
  upgrades: UpgradeEntity[];
}>();
</script>

<style scoped>
.upgrades {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}
</style> 